module.exports = __webpack_public_path__ + "static/media/goldenOak.8079cd61.png";